import { StringParam, useQueryParam, withDefault } from "use-query-params";

import { INHERIT_BUDGET_MIX_KPI } from "@features/mmm/hooks/mmm-url-state";

export const getCacDataStateInitialValue = () => INHERIT_BUDGET_MIX_KPI;

export const useCacDataState = () => {
  return useQueryParam(
    "cac-data",
    withDefault(StringParam, getCacDataStateInitialValue()),
  );
};
